<app-efa-sub-list [previous]="false" #subList>
  <button actions (click)="unassignAll()" class="link">
    {{ 'orgUserGroupUsers.unassignAll' | cxTranslate }}
  </button>
  <a actions class="link" routerLink="../">
    {{ 'organization.done' | cxTranslate }}
  </a>
</app-efa-sub-list>
